import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WebsitesService {

  apiUrl = 'https://admin.invoicing247.com/v1/websites/';//'http://localhost:3003/v1/websites/';

  constructor(private http: HttpClient) { }

  getWebsite(domain: string): Observable<any> {
    return this.http.get(this.apiUrl + domain);
  }
}
